define('NotPurchasableImprovements', [
  'underscore'
], function KodellaNotPurchasableImprovements(
  _
) {
  'use strict';
  return {
    plp: null,
    getItem: function getItem(itemId) {
      var items = this.plp ? this.plp.getItemsInfo() : [];
      return _.findWhere(items, {
        internalid: itemId
      });
    },
    isListItemPurchasable: function isListItemPurchasable(itemId) {
      var item = this.getItem(itemId);

      if(item && item.onlinecustomerprice === 0) {
        return false;
      }
      return item.ispurchasable;
    },
    isItemPurchasable: function (pdp) {
      var iteminfo = pdp.getItemInfo();
      var item = iteminfo.item;
      if(item.onlinecustomerprice_detail && item.onlinecustomerprice_detail.onlinecustomerprice === 0) {
        return false;
      }
      return item.ispurchasable;
    },
    mountToApp: function mountToApp(container) {
      var env = container.getComponent('Environment');
      var config = env && env.getConfig('NotPurchasableImprovements') || {};
      var customNotPurchasableMessage = config && config.notpurchasableMessage;
      var customZeroMessage = config && config.zeroMessage;

      var self = this;
      var pdp = container.getComponent('PDP');
      var plp = container.getComponent('PLP');
      var layout = container.getComponent('Layout');
      var viewNames = [
        pdp.PDP_FULL_VIEW,
        pdp.PDP_QUICK_VIEW
      ];

      this.plp = plp;

      _.each(viewNames, function eachViewName(viewName) {
        pdp.addToViewContextDefinition(viewName, 'notPurchasableImprovementsEnable', 'boolean', function () {
          return true;
        });
        pdp.addToViewContextDefinition(viewName, 'showPurchasableElements', 'boolean', function () {
          return self.isItemPurchasable(pdp);
        });
        pdp.addToViewContextDefinition(viewName, 'notPurchasableReason', 'string', function () {
          var iteminfo = pdp.getItemInfo();
          var item = iteminfo && iteminfo.item;
          if(item.onlinecustomerprice_detail && item.onlinecustomerprice_detail.onlinecustomerprice === 0) {
            return item && customZeroMessage || '';
          }
          return item && customNotPurchasableMessage || '';
        });
      });

      if (layout) {
        layout.addToViewContextDefinition('Facets.ItemCell.View', 'notPurchasableImprovementsEnable', 'boolean', function colorRelations() {
          return true;
        });
        layout.addToViewContextDefinition('Facets.ItemCell.View', 'showPurchasableElements', 'boolean', function colorRelations(context) {
          var itemId = context.itemId;
          return self.isListItemPurchasable(itemId);
        });
        layout.addToViewContextDefinition('Facets.ItemCell.View', 'notPurchasableReason', 'string', function colorRelations(context) {
          var itemId = context.itemId;
          var item = self.getItem(itemId);
          if(item.onlinecustomerprice_detail && item.onlinecustomerprice_detail.onlinecustomerprice === 0) {
            return item && customZeroMessage || '';
          }
          return item && customNotPurchasableMessage || '';
        });
      }
    }
  };
});
